<template>
	<c-dialog ref="dialog" width="550" height="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
            <p class="m-withdraw-time-tip" v-if="withdraw_time_disabled">{{withdraw_time_tip}}</p>
            <c-form-item label="审批结果" required>
                <c-radio-group name="withdraw_status" :options="withdrawStatusDic" v-model="withdrawStatus"></c-radio-group>
            </c-form-item>
            <c-form-item label="打款方式" v-if="withdrawStatus == 3" required :tip="payTypeTip">
                <c-radio-group name="withdraw_pay_type" v-model="withdrawPayType">
                    <c-radio v-for="item in payTypeOptions" :key="item.value" :value="item.value"
                             :disabled="item.value == 1 && withdraw_time_disabled">{{item.name}}</c-radio>
                </c-radio-group>
            </c-form-item>
            <c-form-item label="打款凭证" v-if="withdrawStatus == 3 && withdrawPayType == 0" required>
                <c-upload-file filePath="quote" name="pay_voucher_img_url" v-model="payVoucherUrl" type="image"></c-upload-file>
            </c-form-item>
			<c-form-item label="驳回原因" required v-if="withdrawStatus == 6">
                <c-input type="textarea" name="reject_reason" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
import withdrawTimeMixin from '@/mixins/withdraw_time'

export default {
    name: 'withdrawAudit',
    mixins: [withdrawTimeMixin],

	components: {
	},
	
	data() {
		return {
            //审批结果
            withdrawStatusDic: [
                {name: '审批通过',value: 3,color: 'blue'},
                {name: '审批驳回',value: 6,color: 'red'},
            ],
            withdrawStatus:3,         //审批状态
            withdrawPayTypeDic: [
                {name: '线下打款',value: 0,color: 'blue'},
                {name: '通联打款',value: 1,color: 'red'},
            ],
            withdrawPayType:undefined,        //支付方式
            signContractEnabled:true,         //提现申请人是否已签约（未签约时隐藏通联打款）
            payVoucherUrl:'',                //打款凭证
            withdrawApplyIds:[],              //提现申请ID
            payWindow:null,                   //通联支付页面窗口（占位，避免被浏览器拦截）
            //非通联提现时段只禁用【通联打款】选项，线下打款与审批驳回仍可正常使用
            withdraw_time_tip:'当前不在通联提现受理时间内（每日 07:00-20:00），暂不可选择【通联打款】，可继续选择线下打款或审批驳回'
		}
	},

    watch: {
        //非时段内通联打款被禁用，若已选中则清空，避免跨出时段后仍按通联方式提交
        withdraw_time_disabled(val) {
            if (val && this.withdrawPayType == 1) {
                this.withdrawPayType = undefined;
            }
        }
    },

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
        //打款方式选项（提现申请人未签约时隐藏通联打款）
        payTypeOptions() {
            return this.signContractEnabled ? this.withdrawPayTypeDic : this.withdrawPayTypeDic.filter(item => item.value != 1);
        },
        //打款方式提示语
        payTypeTip() {
            if (this.withdrawStatus != 3){
                return '';
            }
            if (!this.signContractEnabled){
                return '所选提现申请的提现申请人尚未完成通联签约，仅支持线下打款';
            }
            return this.withdrawPayType == 1 ? '使用通联打款，每单将收取1元服务费，由商户主账号承担' : '';
        }
	},

	methods: {
		/*********打开编辑框，初始化**********/
        open(ids, signContract) {
            this.$refs.form.clear();
            this.signContractEnabled = signContract !== false;
            this.withdrawPayType = undefined;          //重置打款方式，避免上次选择残留
            this.$refs.form.set({
                withdraw_status:this.withdrawStatus
            });
            if (ids) {
                this.withdrawApplyIds = ids;
            }
			//填充form表单
			this.$refs.dialog.open({
				title: '提现申请审批'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			//兜底：非时段内不允许以通联打款提交（正常情况下通联选项已禁用、选中值已被清空）
			if (this.withdrawStatus == 3 && this.withdrawPayType == 1 && this.withdraw_time_disabled) {
				this.$message({message: this.withdraw_time_tip});
				return;
			}
			//通联打款：需跳转至通联【确认支付（前台+密码验证版）】页面输入支付密码，先打开空白窗口占位，避免被浏览器拦截
			this.payWindow = null;
			if (this.withdrawStatus == 3 && this.withdrawPayType == 1) {
				this.payWindow = window.open('', '_blank');
			}
			this.$refs.form.submit({
				url: '/withdraw/audit',
				rule: {
                    withdraw_status: '请选择审批结果',
                    withdraw_pay_type: [{
                        type: 'empty',
                        message: '请选择打款方式',
                        skip: () => {
                            return this.withdrawStatus == 6;
                        }
                    }],
                    pay_voucher_img_url: [{
                        type: 'empty',
                        message: '请上传打款凭证',
                        skip: () => {
                            return this.withdrawStatus == 6 || this.withdrawPayType == 1;
                        }
                    }],
                    reject_reason: [{
                        type: 'empty',
                        message: '请输入审核驳回原因',
                        skip: () => {
                            return this.withdrawStatus == 3;
                        }
                    }]
				},
				dataFormatter: data => {
                    data.ids = this.withdrawApplyIds;
                    return data;
				},
				success: (data, res) => {
					next();
					//通联打款：跳转至支付密码确认页面完成付款
					let payUrl = res && res.pay_url ? res.pay_url : '';
					if (payUrl) {
						this.openPayUrl(payUrl);
						this.$message({
							message: '代收单已生成，请在新打开的页面输入支付密码完成付款',
							type: 'success'
						});
					} else {
						this.closePayWindow();
						this.$message({
							message: '提现审批成功',
							type: 'success'
						});
					}
					//延迟秒
					setTimeout(() => {
						this.$emit('resolve');
					}, 1000);
				},
				fail: () => {
					this.closePayWindow();
				}
			});
		},

		//打开通联支付密码确认页面
		openPayUrl(url) {
			if (this.payWindow && !this.payWindow.closed) {
				this.payWindow.location.href = url;
			} else {
				window.open(url);
			}
			this.payWindow = null;
		},

		//关闭未使用的空白窗口
		closePayWindow() {
			if (this.payWindow && !this.payWindow.closed) {
				this.payWindow.close();
			}
			this.payWindow = null;
		}
	}
}
</script>

<style lang="stylus" scoped>
//非通联提现时段的提示条（置于 c-form 内以继承其内边距，宽度占满单列）
.m-withdraw-time-tip {
    box-sizing: border-box;
    width: 100%;
    margin: 0 0 6px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 18px;
    color: #f55;
    background: rgba(250, 140, 22, 0.08);
    border-radius: 4px;
}
</style>